import PortalClienteService from "services/bases/PortalClienteService";

class TenantsService extends PortalClienteService{
    async ListarPorDireito(direitoid){
        return await this.get(`tenants/ListarTenantsPorDireito?direitoId=${direitoid}`)
    }
    async ObterTenantGestaoPortal(tenantId, direitoid){
        return await this.get(`tenants/ObterTenantGestaoPortal?tenantId=${tenantId}&direitoId=${direitoid}`)
    }
}

export default new TenantsService();